import { useCallback } from "react";
import { selectors, useAppSelector } from "store";
import { useGraphDataContext } from "providers/graph-panel";
/**
 * Looks up nodes' letters in the performance results (e.g. "B" for a pump,
 * "a1" for a cup). They are undefined while no valid results are shown — the
 * same condition the overlays' result info is shown under — since the letters
 * come from the shown results and would not match a withheld one.
 */
export var useGetResultAlphabeticalId = function () {
    var getAlphabeticalId = useGraphDataContext().getAlphabeticalId;
    var isPerformanceLoading = useAppSelector(selectors.selectIsPerformanceLoading);
    var isPerformanceDataValid = useAppSelector(selectors.selectIsPerformanceDataValid);
    var hasResultIds = !isPerformanceLoading && isPerformanceDataValid;
    return useCallback(function (nodeId, alphabeticalNodeType) {
        return hasResultIds
            ? getAlphabeticalId(nodeId, alphabeticalNodeType) || undefined
            : undefined;
    }, [getAlphabeticalId, hasResultIds]);
};
/** The node's letter in the performance results, see useGetResultAlphabeticalId */
export var useResultAlphabeticalId = function (nodeId, alphabeticalNodeType) { return useGetResultAlphabeticalId()(nodeId, alphabeticalNodeType); };
